
interface HeaderProps {
  scrolled: boolean;
}

export default function Header({ scrolled }: HeaderProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-xl shadow-sm'
          : 'bg-white/5 backdrop-blur-md'
      }`}
      style={{ height: '80px' }}
    >
      <div className="max-w-7xl mx-auto px-8 h-full flex items-center justify-between">
        <div className="flex items-center">
          <img 
            src="https://public.readdy.ai/ai/img_res/27fb89d6-2bec-49b9-b7c4-9f15a1ac6f59.png" 
            alt="GURTEN SH.P.K. Logo" 
            className="h-10 w-auto mr-4"
          />
          <h1
            className={`text-sm font-extralight uppercase tracking-[3px] transition-colors ${
              scrolled ? 'text-gray-900' : 'text-white'
            }`}
          >
            GURTEN SH.P.K.
          </h1>
        </div>
        <nav className="flex items-center space-x-10">
          {['About', 'Products', 'Features', 'Contact'].map((item) => (
            <button
              key={item}
              onClick={() => scrollToSection(item.toLowerCase())}
              className={`text-[13px] font-light transition-all hover:text-blue-500 relative group cursor-pointer ${
                scrolled ? 'text-gray-700' : 'text-white/90'
              }`}
            >
              {item}
              <span className="absolute bottom-0 left-0 w-0 h-[1px] bg-blue-500 transition-all group-hover:w-full"></span>
            </button>
          ))}
        </nav>
      </div>
    </header>
  );
}